import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { propShape } from '../../../../helpers/custom-prop-types';
import { useThumbnailSlider } from '../../../../helpers/use/useThumbnailSlider';
import SlideSearchNewIcon from '../../../Icon/Svg/SlideSearchNewIcon';
import Hover from '../../../Ui/System/Hover';
import ThumbnailSlider from '../../../Ui/ThumbnailSlider';
const SlideSearchTopMySlideListItemUploaded = (props) => {
    const { item } = props;
    const { isNew, pages } = item;
    const { config, isEnter, onMouseEnter, onMouseLeave, setSliderRef, slideIndex, } = useThumbnailSlider.useThumbnailCustomSlider();
    const images = useMemo(() => pages.map((v) => v.image), [pages]);
    return (_jsx(Hover, Object.assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: _jsxs(Link, Object.assign({ className: 'slide_list_link', to: `/proffit_search/slide/${item.id}` }, { children: [_jsx(ThumbnailSlider, { className: 'slide_list_img', config: config, images: images, isShowCount: isEnter, setSliderRef: setSliderRef, slideIndex: slideIndex }), isNew && !isEnter && (_jsx("span", Object.assign({ className: 'slide_list_newIcon' }, { children: _jsx(SlideSearchNewIcon, {}) })))] })) })));
};
SlideSearchTopMySlideListItemUploaded.propTypes = {
    item: propShape().isRequired,
};
export default SlideSearchTopMySlideListItemUploaded;
